import React, {useEffect, useState} from 'react';
import styled, {useTheme} from 'styled-components';
import PropTypes from "prop-types";
import ShapeSwitch from "../atoms/ShapeSwitch";
import classNames from "classnames";
import {useMeasure} from "react-use";
import {colorSchemeThemes} from "../../utils/styling";

const Holder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  svg {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    transform-origin: center center;
    path, ellipse, circle, rect, polygon { fill: var(--color); }
  }

  &.rotate90 {
    svg {
      transform: rotate(90deg) scaleY(${props => props.ratio}) scaleX(${props => 1 / props.ratio});
    }
  }

  &.rotate180 {
    svg { transform: rotate(180deg); }
  }

  &.rotate270 {
    svg {
      transform: rotate(270deg) scaleY(${props => props.ratio}) scaleX(${props => 1 / props.ratio});
    }
  }
`;

function ControlQuadrant(props) {
  const [ref, {width, height}] = useMeasure();
  const theme = useTheme()
  const [ colors, setColors ] = useState( theme.colors );

  const innerClasses = classNames({
    rotate0: props.settings.rotation === 0,
    rotate90: props.settings.rotation === 90,
    rotate180: props.settings.rotation === 180,
    rotate270: props.settings.rotation === 270,
  });

  useEffect(() => {
    if (props.customScheme >= 0) {
      setColors(colorSchemeThemes[props.customScheme].colors)
    } else {
      setColors(theme.colors)
    }
  }, [props.customScheme, theme.colors]);
  
  return (
    <Holder ref={ref}>
      <Inner
        height={height}
        width={width}
        ratio={width / height}
        className={innerClasses}
        style={{'--color': colors[props.settings.color]}}
      >
        <ShapeSwitch shapeId={props.settings.shape} />
      </Inner>
    </Holder>
  )
}

ControlQuadrant.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default ControlQuadrant;